const whatToSet = function (str) {
	var plainNumber = ('' + str).replace(/\./g, '');
	return parseInt(plainNumber, 10);
};

export const DottedNumberInput = ($filter) => {
	'ngInject';
	return {
		restrict: 'A',
		require: '?ngModel',
		link: (scope, element, attrs, ctrl) => {
			if (!ctrl) return;

			ctrl.$parsers.push(whatToSet);

			ctrl.$formatters.push(function (num) {
				return $filter('dottedNumberFilter')(num);
			});

			element.bind('blur', function () {
				element.val(function () {
					return $filter('dottedNumberFilter')(ctrl.$modelValue);
				});
			});
			element.bind('focus', function () {
				element.val(ctrl.$modelValue);
			});
		}
	};
};
